import { createSlice } from '@reduxjs/toolkit';

import { APP_LIFECYCLE_SLICE_NAME, AppLifecycleSliceState } from './app-lifecycle.slice.types.ts';
import { loadAppThunkExtraReducers } from './thunks/load-app.thunk.ts';

const initialState: AppLifecycleSliceState = {
  isAppInitialized: false,
};

const appLifecycleSlice = createSlice({
  name: APP_LIFECYCLE_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    loadAppThunkExtraReducers(builder);
  },
});

export const AppLifecycleSlice = appLifecycleSlice.reducer;
